import { render, staticRenderFns } from "./ObiImage.vue?vue&type=template&id=59b18b68&scoped=true&"
import script from "./ObiImage.vue?vue&type=script&lang=js&"
export * from "./ObiImage.vue?vue&type=script&lang=js&"
import style0 from "./ObiImage.vue?vue&type=style&index=0&id=59b18b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b18b68",
  null
  
)

export default component.exports